import { env } from '../../../../../../env';
class UrlModules {
  constructor({
    module = ''
  }) {
    this.modules = {
      appgateway: {
        pix: `https://appgateway`,
        url: `.lifekh.com`
      },
      fileserver: {
        pix: `https://fileserver`,
        url: `.lifekh.com`
      }
    };
    if (!module) {
      throw `module is empty!`;
    }
    this.module = module;
    this.isDevelopment = process?.env?.NODE_ENV === 'development';
  }
  get env() {
    return this.isDevelopment && env || (window?.ssrConfig?.routerConfig?.env?.replace(/local|dev/g, env) ?? env);
  }
  /**
   * 根据模块名获取对应的域名
   * @param {'appgateway'} module
   */
  get host() {
    let envPix = '';
    if (this.env && this.env.toLocaleLowerCase() !== 'pro') {
      envPix = `-${this.env}`;
    }
    return `${this.modules[this.module].pix}${envPix}${this.modules[this.module].url}`;
    // return 'http://127.0.0.1:7001'
  }
}
export default UrlModules;
